import { useQuery } from "@tanstack/react-query";
import { ApiGetPlatformCexSymbolDayStats } from "@/api";
import type {
  GetPlatformCexSymbolDayStatsRequest,
  GetPlatformCexSymbolDayStatsResponse,
} from "@/api/types";

/**
 * 获取平台维度某业务日各交易对的交易量/盈亏统计
 * 对应接口：`/game/cex/GetPlatformCexSymbolDayStats`
 */
export function useGetPlatformCexSymbolDayStats(
  params?: GetPlatformCexSymbolDayStatsRequest
) {
  return useQuery({
    queryKey: ["platformCexSymbolDayStats", params?.statDay ?? ""],
    queryFn: async (): Promise<GetPlatformCexSymbolDayStatsResponse> => {
      const res = await ApiGetPlatformCexSymbolDayStats(params ?? {});
      console.log("useGetPlatformCexSymbolDayStats", res.data);
      return res.data;
    },
    refetchInterval: 1000 * 8,
  });
}
